import {combineReducers} from 'redux';

import authReducer from './authReducer';

import flyersReducer from './flyersReducer';

import flyerDetailsReducer from './flyerDetailsReducer';
import changedStateForFlyerReducer from './changedStateForFlyerReducer';

import flippingFlyerReducer from './flippingFlyerReducer';
import smartFlyerReducer from './smartFlyerReducer';

import guiSettings from './guiSettingsReducer';
import pagesReducer from "./pagesReducer";
import selectPageForTabsReducer from "./selectedPageForTabReducer";
import saleTypesReducer from "./saleTypesReducer";

import spots from './spotsReducer'
import promotionsAndItems from './promotionsAndItemsReducer'
import flyerConversionSettingsReducer from "./flyerConversionSettingsReducer";
import toggleActionsForFlyers from "./toggleActionForEditorReducer";
import sellingUnitsReducer from "./sellingUnitsReducer";
import accountSettingsAndLangReducer from "./accountSettingsAndLangReducer";
import accountEmailsSettingsReducer from "./accountEmailsSettingsReducer";
import analyticsDataReducer from "./analyticsDataReducer";
import createFlyerFromPdfReducer from "./flyerFromPdfReducer";
import flyersFiltersReducer from "./flyersFiltersReducer";
import {uploadingImagesProgressReducer} from "./uploadingImagesProgressReducer";
import {tocForPagesReducer} from "./tocForPagesReducer";
import {createFlyerFromJpegsReducer} from "./flyerFromJpegsReducer";
import {createFlyerWithoutPageImagesReducer} from "./flyerWithoutPageImagesReducer";
import {flyerClassesReducer} from "./flyerClassesReducer";
import {DownloadFileReducer} from "./downloadFileReducer";
import accountStoreSettingsReducer from "./accountStoreSettingsReducer";
import storeShelfStylesReducer from "./storeShelfStylesReducer";
import {storeForAccountReducer} from "./storeForAccountReducer";
import usersAndPermissionsReducer from "./usersAndPermissionsReducer";
import updatePassword from "./updatePasswordReducer";

const reducers = combineReducers({
    auth: authReducer,
    analyticsData: analyticsDataReducer,
    flyers: flyersReducer,

    flyerDetails: flyerDetailsReducer,

    changedStateForFlyer: changedStateForFlyerReducer,

    flippingFlyer: flippingFlyerReducer,
    smartFlyer: smartFlyerReducer,

    guiSettings: guiSettings,

    pages: pagesReducer,
    selectPageForTabs: selectPageForTabsReducer,

    spots: spots,
    promotionsAndItems: promotionsAndItems,
    storeForAccount: storeForAccountReducer,
    saleTypes: saleTypesReducer,
    sellingUnits: sellingUnitsReducer,
    conversionUrlSetting: flyerConversionSettingsReducer,
    toggleActionsForFlyers: toggleActionsForFlyers,
    accountSettingWithLang: accountSettingsAndLangReducer,
    uploadImagesPopup: uploadingImagesProgressReducer,
    flyerDataFromPdf: createFlyerFromPdfReducer,
    flyerDataFromJpegs: createFlyerFromJpegsReducer,
    flyerDataWithoutImages: createFlyerWithoutPageImagesReducer,
    tocForPage: tocForPagesReducer,
    flyerClasses: flyerClassesReducer,
    downloadFileState: DownloadFileReducer,
    flyersFiltersState: flyersFiltersReducer,
    accountEmailsState: accountEmailsSettingsReducer,
    accountStoreSettings: accountStoreSettingsReducer,
    usersAndPermissions: usersAndPermissionsReducer,
    storeShelfStyles: storeShelfStylesReducer,

    updatePassword: updatePassword
})

export default reducers;


// take the reducers function and return back whatever type 
// that function returns
export type RootState = ReturnType<typeof reducers>;





